import { createImageLabelBrowseLoader } from '@modules-rocco/projects/page/image-label-browse-loader.server';
import ProjectImageLabelBrowsePage from '@modules-rocco/projects/page/ProjectImageLabelBrowsePage';
import { imageLabelBrowseHandle } from '@modules-rocco/projects/page/image-label-browse-handle';
import { createImageLabelBrowseMeta } from '@modules-rocco/projects/page/image-label-browse-meta';
import { imageLabelShouldRevalidate } from '@modules-rocco/projects/page/image-label-browse-revalidate';

/** Browse project photography by architectural style. */
export const loader = createImageLabelBrowseLoader('styles');

export const meta = createImageLabelBrowseMeta('styles');

export const handle = imageLabelBrowseHandle;
export const shouldRevalidate = imageLabelShouldRevalidate;

export default ProjectImageLabelBrowsePage;
